import { default as LinkComponent } from 'components/Link';
import { styled } from '@mui/material/styles';
import Logo from 'components/Logo';

export const LogoLink = styled(LinkComponent)(() => ({
  color: 'inherit',
  marginRight: 'auto'
}));

export const AppLogo = styled(Logo)(() => ({
  color: 'inherit',
  height: '5em'
}));
